module.exports = __webpack_public_path__ + "static/img/genomics_clusters_4.a722603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/genomics_clusters_4.png
// module id = 7k+V
// module chunks = 6